import React, { useEffect, useState } from "react";
import { Button, Form, Spin } from "antd";
import { FieldTypes, generateFormFields } from "utils/formUtils";
import GlobalSettingAPI from "restAPI/GlobalSettingAPI";
import message from "components/CustomMessage";
import AppLoader from "components/AppLoader";

const CheckmarxCodebashingForm = ({ name: trainingName, ...props }) => {
  const [isEnabled, setIsEnabled] = useState(false);
  const [tenantId, setTenantId] = useState();
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const { promise, cancel } = GlobalSettingAPI.getCodeBashingConfig();
    promise
      .then((data) => {
        setLoading(true);
        if (data) {
          setIsEnabled(data.isEnabled);
          setTenantId(data.tenantId);
        } 
      })
      .finally(() => setLoading(false));
    return () => {
      cancel();
    };
  }, [form]);

  useEffect(() => {
    form.setFieldsValue({
      isEnabled: isEnabled,
      tenantId: isEnabled === false ? "" : tenantId,
    });
  }, [isEnabled, tenantId, form]);

  const handleSave = async () => {
    try {
      await form.validateFields();
      const config = {
        isEnabled: form.getFieldValue("isEnabled"),
        tenantId: form.getFieldValue("tenantId"),
      };

      const { promise, cancel } =
        GlobalSettingAPI.updateCodeBashingConfig(config);
      promise.then(() => {
        form.setFieldsValue({
          isEnabled: config.isEnabled,
          tenantId: config.tenantId,
        });
        message.success(
          `Codebashing ${config.isEnabled ? "enabled" : "disabled"} successfully`);
      });
      return cancel;
    } catch (errorInfo) {
      console.error("Validation failed");
    }
  };

  const handleToggle = (checked) => {
    setIsEnabled(checked);
  };

  const fields = [
    {
      name: "isEnabled",
      label: "Enable/Disable Codebashing",
      type: FieldTypes.SWITCH,
      inline: true,
      props: {
        onChange: handleToggle,
      },
    },
    {
      name: "tenantId",
      label: "Tenant ID",
      type: "textfield",
      colSpan: 24,
      placeholder: "Enter the tenant ID provided by the Codebashing team",
      required: isEnabled,
      disabled: !isEnabled,
    },
  ];

  return (
    <Spin spinning={loading} indicator={<AppLoader />}>
      <Form
        form={form}
        layout="vertical"
        style={{ padding: "20px", maxWidth: "400px" }}
      >
        {generateFormFields(fields)}

        <Button type="primary" onClick={handleSave}>
          Save
        </Button>
      </Form>
    </Spin>
  );
};

export default CheckmarxCodebashingForm;
